import React from 'react'
import './index.scss'
// import { viewWindDialog } from '../../../../../../action/check-wind-dialog-actions'
import { connect } from 'react-redux'
import isNil from 'lodash/isNil'
import { expandRightToolbar } from '../../../../../../../action/right-toolbar-state-actions';
import huntImage from '../../../../../../../../asset/Wind-Icon_Large_FFFFFF_SVG.svg';
import NorthWind from '../../../../../../../../asset/wind-preview-green.png'

class IdealWind extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    const { marker, expandRightToolbar } = this.props,
      windClick = () => {
        expandRightToolbar({ dialog: 'huntWind', data: marker })
      }
    let extendedData = null,
      idealWinds = []
    try {
      extendedData = JSON.parse(marker.extendedData)
      idealWinds = isNil(extendedData.huntStandData) ||
        isNil(extendedData.huntStandData.preferredWindDirections) ||
        extendedData.huntStandData.preferredWindDirections.length === 0 ? [] :
        extendedData.huntStandData.preferredWindDirections
    } catch (error) {
      idealWinds = []
    }

    return idealWinds.length > 0 ? (
      <div className='set-wind-icon'>
        {/* Ideal Wind */}
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', width: '200px',
        }}>
          <div style={{
            width: '200px',
            height: '95px;',
            position: 'relative',
            marginTop: '5px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <div style={{
              color: 'white',
              display: 'flex'
            }}
            >
              <h3 style={{
                color: '#ffffff',
                font: 'normal normal normal 30px/45px Oswald'
              }}>HuntWind&#8482;</h3>
            </div>

            <img src={huntImage} style={{
              width: '39px',
              height: '14px'
            }}></img>

          </div>
          <button style={{ width: '200px', height: '40px' }}
            onClick={() => { windClick({ marker, action: 'view' }) }}>
            Edit
          </button>
        </div>
      </div >
    ) : (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', cursor: 'pointer', height: '95px;', }}
          onClick={() => { windClick({ marker, action: 'edit' }) }}>
          <p style={{ pointerEvents: 'none' }}>None Selected</p>
          <p style={{ color: 'rgb(88,149,0)', pointerEvents: 'none' }}>SET IDEAL WINDS</p>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  expandRightToolbar: props => dispatch(expandRightToolbar(props))
})

export default connect(() => { return {} }, mapDispatchToProps)(IdealWind)